import React from "react";
import Select from "react-select";
import useEditPayment from "../../controllers/useEditPayment";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import InputField from "../components/InputField";
import ErrorMessage from "../components/errorMessage";
import { Modal } from "react-bootstrap";

const Updatepayment = ({ show, setShow, rowData, onClose }) => {
  const { values, functions } = useEditPayment(rowData, setShow);
  console.log("values", values, functions);

  const paymenttype = [
    { value: "Choose", label: "Choose" },
    { value: "Cash", label: "Cash" },
    { value: "Cheque", label: "Cheque" },
    { value: "Wire", label: "Wire" },
  ];
  return (
    // <div
    //   className="modal fade"
    //   id="editpayment"
    //   tabIndex={-1}
    //   aria-labelledby="editpayment"
    //   aria-hidden="true"
    // >
    //   <div className="modal-dialog modal-lg modal-dialog-centered">
    //     <div className="modal-content">
    //       <div className="modal-header border-0 custom-modal-header">
    //         <div className="page-title">
    //           <h4>Edit Payments</h4>
    //         </div>
    //         <button
    //           type="button"
    //           className="close"
    //           data-bs-dismiss="modal"
    //           aria-label="Close"
    //           onClick={onClose}
    //         >
    //           <span aria-hidden="true">×</span>
    //         </button>
    //       </div>
    //       <div className="modal-body custom-modal-body">
    //         <form>
    //           <div className="row">
    //             <div className="col-lg-12 col-sm-12 col-12">
    //               <label className="form-label">
    //                 Payment Type <span className="text-danger">*</span>
    //               </label>
    //               <Controller
    //                 name="paying_type"
    //                 control={values.control}
    //                 rules={{ required: "Payment Type is required" }}
    //                 render={({ field }) => (
    //                   <Select
    //                     {...field}
    //                     classNamePrefix="react-select"
    //                     className="mb-2"
    //                     options={paymenttype}
    //                     placeholder="Select Payment Type"
    //                     isDisabled={true}
    //                     value={paymenttype?.find(
    //                       (option) => option.value == field.value
    //                     )}
    //                     onChange={(selectedOption) =>
    //                       field.onChange(selectedOption.value)
    //                     }
    //                   />
    //                 )}
    //               />
    //               <ErrorMessage error={values?.errors?.paying_type?.message} />
    //             </div>
    //             <div className="col-lg-12">
    //               <Controller
    //                 name="description"
    //                 rules={{ required: "Description is required",  maxLength: 60 }}
    //                 control={values.control}
    //                 render={({ field }) => (
    //                   <InputField
    //                     label="Description"
    //                     type="textarea"
    //                     required
    //                     placeholder="Enter Description"
    //                     {...field}
    //                   />
    //                 )}
    //               />
    //               <p>Maximum 60 Characters</p>
    //               <ErrorMessage error={values?.errors?.description?.message} />
    //             </div>
    //           </div>
    //           <div className="col-lg-12">
    //             <div className="modal-footer-btn mb-3 me-3">
    //               <button
    //                 type="button"
    //                 className="btn btn-cancel me-2"
    //                 data-bs-dismiss="modal"
    //                 onClick={onClose}
    //               >
    //                 Cancel
    //               </button>
    //               <button
    //                 onClick={functions.onSubmit}
    //                 type="submit"
    //                 className="btn btn-submit"
    //               >
    //                 Save Changes
    //               </button>
    //             </div>
    //           </div>
    //         </form>
    //       </div>
    //     </div>
    //   </div>
    // </div>

    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      className="modal fade"
    >
      <Modal.Header className="modal-header border-0 custom-modal-header">
        <Modal.Title>Edit Payments</Modal.Title>
        <button type="button" className="close" onClick={onClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="mb-3">
            <label className="form-label">
              Payment Type <span className="text-danger">*</span>
            </label>
            <Controller
              name="paying_type"
              control={values.control}
              rules={{ required: "Payment Type is required" }}
              render={({ field }) => (
                <Select
                  {...field}
                  classNamePrefix="react-select"
                  options={paymenttype}
                  placeholder="Select Payment Type"
                  isDisabled={true}
                  value={paymenttype.find(
                    (option) => option.value === field.value
                  )}
                  onChange={(selectedOption) =>
                    field.onChange(selectedOption.value)
                  }
                />
              )}
            />
            <ErrorMessage error={values?.errors?.paying_type?.message} />
          </div>
          <div className="mb-3">
            <Controller
              name="description"
              rules={{ required: "Description is required" }}
              control={values.control}
              render={({ field }) => (
                <InputField
                  label="Description"
                  type="textarea"
                  required
                  placeholder="Enter Description"
                  {...field}
                />
              )}
            />
            <p>Maximum 60 Characters</p>
            <ErrorMessage error={values?.errors?.description?.message} />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-lg-12">
          <div className="modal-footer-btn mb-3 me-3">
            <button
              type="button"
              className="btn btn-cancel me-2"
              data-bs-dismiss="modal"
              onClick={onClose}
              style={{ minWidth: "80px", height: "35px", padding: 5, fontSize: "14px" }} // Adjust size
            >
              Cancel
            </button>
            <button
              onClick={functions.onSubmit}
              type="submit"
              className="btn btn-submit"
              style={{ minWidth: "80px", height: "35px", padding: 5, fontSize: "14px" }} // Adjust size
            >
              Submit
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

Updatepayment.propTypes = {
  setShow: PropTypes.any,
  show: PropTypes.bool,
  rowData: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export default Updatepayment;
